import React from "react";
import ContractFarming from "../../assets/images/Services/contract-manufacturing.jpg";
import PrivateLabelling from "../../assets/images/Services/private-labelling.jpg"

import image3 from "../../assets/images/livasa-about/spa-concept-self-care-with-honey-coffee-turmeric-natural-organic-cosmetics-homemade-product-alternative-lifestyle.jpg";
import AboutSectionSubsection1 from "../../components/AboutSection1/AboutSectionSubsection1";
function ManufacturingOnDemand() {
  const serviceData = [
    {
      title: "Contract Manufacturing",
      description:
        "ApisChain specializes in providing contract manufacturing services, catering to diverse product needs. With a proven track record of expertise and reliability, We collaborate closely with brands to bring their concepts to life. From formulation to production and packaging, ApisChain ensures a seamless manufacturing process, delivering high-quality products that meet client specifications.        ",
      image: ContractFarming,
    },

    {
      title: "Private Labelling",
      description:
        " ApisChain excels in private labeling services, allowing businesses to brand high-quality products as their own. Through this service, brands can leverage ApisChain's expertise to bring their unique products to market with a personalized touch.        ",
      image: PrivateLabelling,
      rowreverse: "true",
    },

    {
      title: "New Product Development",
      description:
        "ApisChain offers new product development services tailored to brands, helping them innovate and diversify their product offerings to meet evolving market demands.          ",
      image: image3,
    },
  ];
  return (
    <div className="container">
      {serviceData.map((data, index) => {
        return (
          <AboutSectionSubsection1
            key={index}
            src={data.image}
            bodycopy={data.description}
            title={data.title}
            rowreverse={data.rowreverse}
          />
        );
      })}
    </div>
  );
}

export default ManufacturingOnDemand;
